import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { RemoveTrackerButton } from '../../../components/common/buttons/RemoveTrackerButton.tsx'
import { TrackerAssignmentButton } from '../../../components/common/buttons/TrackerAssignmentButton.tsx'
import { petFromDevice, readableSeconds, renewsOn } from '../../../helpers/dataHelpers.ts'
import controlStore from '../../../store/controlStore.ts'
import dataStore from '../../../store/dataStore.ts'
import { ISubscription } from '../../../interfaces/types.ts'
import { UpgradeSubscriptionButton } from '../../../components/common/buttons/UpgradelSubscriptionButton.tsx'
import { ly } from '../../../helpers/petHelper.tsx'
import { ProvisionDeviceButton } from '../../../components/common/buttons/ProvisionDeviceButton.tsx'
import { isAdvancedSettingsEnabled } from '../../../helpers/sleepHelper.ts'
import { AdvancedSettings } from '../../../components/common/AdvancedSettings/AdvancedSettings.tsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGear } from '@fortawesome/free-solid-svg-icons/faGear'


interface Props {
}


export const TrackerSubscriptionList: React.FC<Props> = () => {
    const subscriptions = dataStore(s => s.devicePlans)
    const devices = dataStore(s => s.devices)
    const navigate = useNavigate()
    const isMobile = controlStore(s => s.isOnMobileDevice)
    const [activeSubscriptions, setActiveSubscriptions] = React.useState<ISubscription[]>([])
    const [advancedOpenId, setAdvancedOpenId] = React.useState<string | null>(null)
    const advancedEnabled = isAdvancedSettingsEnabled()
    const timezones = dataStore(s => s.timeZones)
    const tzId = dataStore.getState().account.timeZone
    const timeZone = timezones.find(t => t._id === tzId)

    React.useEffect(() => {
        if (subscriptions.length) {
            const activeDevices = devices?.map(d => d.iccid) || []
            const tmp = subscriptions.filter((a: ISubscription) => activeDevices.includes(a.deviceId))
            setActiveSubscriptions(tmp)
        } else {
            setActiveSubscriptions([])
        }
    }, [subscriptions, devices])

    const header = (
        <div className={'pt-2'}>
            <h1 className="text-3xl font-semibold text-center text-primary mb-2">Gibi Trackers</h1>
        </div>
    )

    console.log(activeSubscriptions)

    const altList = activeSubscriptions.length ? (
        <div className={'flex flex-col gap-4'}>
            {devices?.map(c => {
                const pet = petFromDevice(c)
                const sub = activeSubscriptions.find(s => s.deviceId === c.iccid)
                console.log(sub)
                const planType = sub ? sub.planType.includes('ly') ? sub.planType : ly(sub.planType)
                    : ''
                const borderStyle = pet ? 'border-l-primary' :  'border-l-accent'
                return (
                    <div key={c._id}
                         className={`flex flex-col justify-start w-full  border-l-4 bg-white px-4 ${borderStyle}`}>

                        <div className={'flex items-center justify-between p-2 pb-3'}>
                            <div className={'text-lg text-left font-semibold'}>
                                {c.deviceName}
                            </div>

                            <div className="text-base-content font-medium min-w-[50%] text-right">
                                {pet ?
                                    <span>
                                        <span className={'text-neutral-content/50'}>Assigned to: </span>
                                        <span className={'font-semibold'}>
                                            {pet.petName}
                                        </span>
                                    </span>
                                    : <span className={'font-semibold'}>
                                            unassigned
                                    </span>}
                            </div>
                        </div>

                        <div className={'flex justify-between w-full rounded-lg bg-primary/5 p-2 border-2 border-primary/10'}
                        >
                            <div className={'flex flex-col text-left text-base-content font-medium p-2 pt-0'}>
                                <div className={'text-neutral-content/50'}>ID</div>
                                <div className={'font-semibold pl-2'}>{c.iccid}</div>

                                <div className={'text-neutral-content/50'}>Check-in rate</div>
                                <div
                                    className={'font-semibold pl-2'}>{readableSeconds(c.status?.backgroundInterval)}</div>
                            </div>

                            <div className={'flex flex-col gap-0 text-left text-base-content font-medium p-2 pt-0'}>
                                <div className={'text-neutral-content/50'}>
                                    {planType} Service Plan
                                </div>

                                <div
                                    className={'font-semibold pl-2'}>${sub?.planAmount}</div>

                                <div className={'text-neutral-content/50'}>Renews next</div>
                                <div
                                    className={'font-semibold pl-2'}>{renewsOn(timeZone, sub?.planStart, sub?.planType)}</div>
                            </div>
                        </div>

                        <div className={'flex items-center justify-around w-full p-2'}>
                            <TrackerAssignmentButton tracker={c} unassign/>
                            {/*<TrackerAssignmentButton tracker={c} short/>*/}
                            {c.isActive ? null : <ProvisionDeviceButton tracker={c}/>}
                            {sub?.planType === 'month' ? <UpgradeSubscriptionButton subscription={sub}/> : null}
                            <RemoveTrackerButton tracker={c}/>
                            {advancedEnabled && (
                                <button
                                    className={'btn btn-ghost btn-sm opacity-50'}
                                    onClick={() => setAdvancedOpenId(c._id)}
                                >
                                    <FontAwesomeIcon icon={faGear} />
                                </button>
                            )}
                        </div>
                        {advancedEnabled && advancedOpenId === c._id && (
                            <AdvancedSettings
                                tracker={c}
                                open={true}
                                setOpen={(o) => !o && setAdvancedOpenId(null)}
                                disabled={!!c.status.deviceCommandInProgressStatus || !c.status.powerOn || c.status.sleeping}
                            />
                        )}
                    </div>
                )
            })
            }
        </div>
    ) : null

    const width = !isMobile ? '' : ''

    return (
        <div className={`${width} h-[90vh] overflow-y-auto`}>
            {header}
            {altList}
            <input
                type={'button'}
                className={'mt-4 btn btn-ghost text-primary'}
                onClick={() => navigate('/' + controlStore.getState().currentPage)}
                value={'Close'}
            />
        </div>
    )
}
